import React, { useEffect, useState } from "react";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { redirect, useLocation, useParams } from "react-router";

const EmailAnlaytics = () => {
  const { encodedEmail } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const templateName = params.get("TemplateName");
  const linkType = params.get("linktype");
  const redirectLink = params.get("redirectLink");

  useEffect(() => {
    performRequest("POST", `/bulkemail/email-anlaytics`, {
      templateName: templateName,
      encodedEmail: encodedEmail,
      linkType: linkType,
      redirectLink: redirectLink,
    })
      .then((res) => {
        if (res.status === 200) {
          window.location.href = `${res.data}`;
        }
      })
      .catch((err) => {
        Toast("error", "Internal Error");
        console.error(err);
      });
  },[]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <h1>PleastWait</h1>
    </div>
  );
};

export default EmailAnlaytics;
